import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-248a33a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "nav" }

import HeaderGame from './components/HeaderGame.vue'
import NavigationGame from './components/NavigationGame.vue'
import { RouterView } from 'vue-router'
// import HomeGame from './pages/HomeGame.vue'
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

onMounted(() => {
  store.dispatch('createNewWord')
})

window.addEventListener('keydown', ({ key }) => {
  if (isLose.value || isWin.value) {
    return
  }

  if (/[а-яА-ЯёЁ]/.test(key)) {
    store.commit('setLetter', key)

    if (store.getters.getLetterArray.includes(key)) {
      store.commit('setNotificationDouble', true)
      setTimeout(() => store.commit('setNotificationDouble', false), 2000)
      return
    }
    store.commit('setLetterArray', key)   
    store.commit('setRightLetters', key)
  }
})

const isLose = computed(() => store.getters.getWrongLetters.length === 6)
const isWin = computed(() => [...store.getters.getWord].every((x) => store.getters.getRightLetters.includes(x)))


return (_ctx: any,_cache: any) => {
  const _component_HomeGame = _resolveComponent("HomeGame")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderGame)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NavigationGame)
    ]),
    _createVNode(_unref(RouterView), {
      isWin: isWin.value,
      isLose: isLose.value
    }, null, 8, ["isWin", "isLose"]),
    _createVNode(_component_HomeGame)
  ], 64))
}
}

})